<div class="container-fluid m-0 p-0" *ngIf="!showLoader">


    <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
        <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
            <h6 class="font-bold m-0">{{ "LECTURE_SCHEDULE" | translate | titlecase }}</h6>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-12">
            <form [formGroup]="searchForm" (change)="searchFormChange()" (submit)="searchFormSubmit()">
                <div class="row bg-white border m-0 py-3">
                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            <div class="col-md-4 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "ACADMIC_YEAR" | translate | titlecase }}</label>
                                <select class="form-control" formControlName="year" (change)="getYearSemesters()">
                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                    }}
                                </option>
                                <option *ngFor="let field of years" [ngValue]="field.id">
                                    {{
                                    (globals.lang == 'ar')? field?.yearDescAr : field?.yearDescEn
                                    }}
                                </option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="searchForm.controls.year.touched && searchForm.controls.year.invalid && searchForm.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-4 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "SEMESTER" | translate | titlecase }}</label>
                                <select class="form-control" formControlName="semester" (change)="getBatches()">
                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                    }}
                                </option>
                                <option *ngFor="let field of semesters" [ngValue]="field.id">
                                    {{
                                    (globals.lang == 'ar')? field?.semesterNameAr :
                                    field?.semesterNameEn
                                    }}
                                </option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="searchForm.controls.semester.touched && searchForm.controls.semester.invalid && searchForm.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-4 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "BATCH" | translate | titlecase }}</label>
                                <select class="form-control" formControlName="batch">
                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                    }}
                                </option>
                                <option *ngFor="let field of batches" [ngValue]="field.id">
                                    {{
                                    (globals.lang == 'ar')? field?.gradeNameAr : field?.gradeNameEn
                                    }}
                                </option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="searchForm.controls.batch.touched && searchForm.controls.batch.invalid && searchForm.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-end">
                            <div class="col-3">
                                <button type="reset" class="btn btn-outline-secondary m-2 rounded-0">
                                    {{ "RESET" | translate | titlecase }}</button>
                                <button type="submit" class="btn btn-primary m-2 rounded-0"><i class="fas fa"></i>
                                    {{ "SEARCH" | translate | titlecase }}</button>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-md-12 d-flex flex-wrap justify-content-center justify-content-lg-end">
                    <button type="reset" class="btn btn-outline-secondary m-2 rounded-0">
                        {{ "RESET" | translate | titlecase }}</button>
                    <button type="submit" class="btn btn-primary m-2 rounded-0"><i class="fas fa"></i>
                        {{ "SEARCH" | translate | titlecase }}</button>
                </div> -->
                </div>
            </form>
            <!-- <form [formGroup]="lectureScheduleSlots" (change)="lectureScheduleSlotsChange()"
                (submit)="lectureScheduleSlotsSubmit()">
                <div class="row bg-white border m-0 py-3">

                    <div class="table-responsive py-3" *ngIf="!showLoader">
                        <table *ngIf="slots.length >= 1" class="table-striped" id="datatable">
                            <thead>
                                <tr>
                                    <th>{{ "ID" | translate | titlecase }}</th>
                                    <th>{{ "DAY" | translate | titlecase }}</th>
                                    <th>{{ "TIME_SLOT" | translate | titlecase }}</th>
                                    <th>{{ "START_TIME" | translate | titlecase }}</th>
                                    <th>{{ "END_TIME" | translate | titlecase }}</th>
                                    <th>{{ "SLOT_TYPE" | translate | titlecase }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let res of slots let i = index">
                                    <td>{{res?.id}}</td>
                                    <td>{{res?.day}}</td>
                                    <td>{{res?.timeSlot}}</td>
                                    <td>{{res?.startTime}}</td>
                                    <td>{{res?.endTime}}</td>
                                    <td>
                                        <select class="form-control custom-select"
                                            formControlName="{{res?.slotTypeContorlName}}">
                                            <option [ngValue]="">{{ "SELECT" | translate | titlecase }}</option>
                                            <option value="lecture">{{ "LECTURE" | translate | titlecase }}</option>
                                            <option value="rest">{{ "REST" | translate | titlecase }}</option>
                                        </select>
                                        <div class="alert alert-danger py-1 mt-1"
                                            *ngIf="isTouched(res?.slotTypeContorlName) && isInvalid(res?.slotTypeContorlName) && lectureScheduleSlots.dirty">
                                            {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-md-12 d-flex flex-wrap justify-content-center justify-content-lg-end">
                        <button type="submit" class="btn btn-primary m-2 rounded-0"><i class="fas fa"></i>
                            {{ "UPDATE" | translate | titlecase }}</button>
                    </div>
                </div>
            </form> -->
        </div>
    </div>

</div>

<app-loader [attr.show]="showLoader"></app-loader>